import React, { useState, useEffect } from 'react'
import TableRow from './TableRow.js'
import forEachRight from 'lodash/forEachRight'
import _, { filter } from 'lodash'
import { Input } from 'semantic-ui-react'
import AdminLogin from './AdminLogin'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import {
//   faArrowLeftLong,
//   faArrowRightLong,
// } from '@fortawesome/free-solid-svg-icons'

export default function Admin() {
  const json = require('../../../rooms.json')
  const [token, setToken] = useState()
  const [filteredJson, setFilteredJson] = useState([])
  const [initialLoad, setInitialLoad] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [recordsPerPage] = useState(25)
  const [pages, setPages] = useState(0)
  const [activeRows, setActiveRows] = useState([])
  const [paginationButtons, setPaginationButtons] = useState([])
  const [searchInput, setSearchInput] = useState('')
  const [filteredPaginationButtons] = useState([1])

  //Dynamic Pagination
  function populatePaginationButtons() {
    setPages(Math.ceil(filteredJson.length / recordsPerPage))
    setPaginationButtons([])
    const activePaginationButtons = [...Array(pages + 1).keys()]
    activePaginationButtons.splice(0, 1)

    setPaginationButtons(activePaginationButtons)
  }

  function filterPagination() {
    let filteredPages = paginationButtons.filter(
      (page) => page < currentPage + 3,
    )

    if (filteredPages.length > 5) {
      do {
        filteredPages.splice(0, 1)
      } while (filteredPages.length > 5)
    }
    return filteredPages
  }

  // Search function
  function populateFilteredRows(filteredData) {
    setActiveRows([])

    let newFilteredRows = []

    for (
      let i = (currentPage - 1) * recordsPerPage;
      i < currentPage * recordsPerPage;
      i++
    ) {
      if (filteredData[i] !== undefined) {
        newFilteredRows.push(
          <TableRow
            data={filteredData[i]}
            key={i}
            isSearched={true}
            dark={i % 2 === 0 ? true : false}
          />,
        )
      } else {
        continue
      }
      setActiveRows(newFilteredRows)
    }
  }

  function searchItems(searchValue) {
    setSearchInput(searchValue)
    const filteredData = _.filter(filteredJson, function (o) {
      return o.owner_email.toLowerCase().includes(searchValue.toLowerCase())
    })
    populateFilteredRows(filteredData)
  }

  //Filter by recent(reversed array) and cut rooms with no owner_email
  function filterJson() {
    if (!initialLoad) {
      let data = json
      forEachRight(data, function (value, key) {
        if (value.owner_email === '') {
          data.splice(key, 1)
        }
      })
      data.reverse()
      setFilteredJson(data)
      setInitialLoad(true)
    } else {
      return false
    }
  }

  function onClickHandler(button) {
    setCurrentPage(button)
    filterPagination()
  }

  function populateRows() {
    // Empty active rows to make way for new data
    let newRows = []

    for (
      let i = (currentPage - 1) * recordsPerPage;
      i < currentPage * recordsPerPage;
      i++
    ) {
      if (filteredJson[i] !== undefined) {
        newRows.push(
          <TableRow
            data={filteredJson[i]}
            key={i}
            isSearched={false}
            dark={i % 2 === 0 ? true : false}
          />,
        )
      } else {
        continue
      }
    }
    populatePaginationButtons()
    setActiveRows(newRows)
  }

  useEffect(() => {
    if (!initialLoad) {
      filterJson()
    } else {
      populateRows()
    }
  }, [currentPage, pages, filteredJson])

  if (!token) {
    return <AdminLogin setToken={setToken} />
  }

  return (
    <div className="admin-panel-container">
      <table className="admin-panel-table">
        <caption>Brand Deck Admin Panel</caption>
        <Input
          className="searchbar"
          icon="search"
          placeholder="Search email..."
          onChange={(e) => searchItems(e.target.value)}
        />
        <thead>
          <tr>
            <th scope="col">Email</th>
            <th scope="col">Room Link</th>
            <th scope="col">Room Key</th>
            <th scope="col">Subscription Id</th>
            <th scope="col">Subscription Status</th>
            <th scope="col">Room Status</th>
          </tr>
        </thead>
        <tbody id="bd-rooms-table">{activeRows}</tbody>
      </table>

      <div className="admin-panel-pagination-container" id="bd-pagination">
        <div className="admin-panel-pagination-buttons">
          {currentPage === 1 ? null : (
            <>
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                className="admin-panel-pagination-button pagination-arrow"
              >
                prev
              </button>
            </>
          )}
          {currentPage < 4 ? null : (
            <>
              <button
                onClick={() => setCurrentPage(1)}
                className="admin-panel-pagination-button"
              >
                1
              </button>
              <div className="pagination-divider">...</div>
            </>
          )}
          {searchInput.length > 0
            ? filteredPaginationButtons.map((btn) => (
                <button
                  key={btn}
                  className={`admin-panel-pagination-button 
                ${currentPage === btn ? 'active-page' : ''}
                `}
                  onClick={() => setCurrentPage(btn)}
                >
                  {btn}
                </button>
              ))
            : filterPagination().map((btn) => (
                <button
                  key={btn}
                  className={`admin-panel-pagination-button 
                ${currentPage === btn ? 'active-page' : ''}
                `}
                  onClick={() => onClickHandler(btn)}
                >
                  {btn}
                </button>
              ))}
          {currentPage > pages - 3 ? null : (
            <>
              <div className="pagination-divider">...</div>
              <button
                onClick={() => setCurrentPage(pages)}
                className="admin-panel-pagination-button"
              >
                {pages}
              </button>
            </>
          )}
          {currentPage === pages ? null : (
            <>
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                className="admin-panel-pagination-button pagination-arrow"
              >
                next
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
